import React from "react";
import { useEffect, useState } from "react";
import MauvaisGazo from "../music/gazo-mauvais.mp3";
import MauvaisGazoPic from "../img/kmt-mauvais.jpg";
import AllerPointer from "../music/aller-pointer.mp3";
import AllerPointerPic from "../img/aller-pointer.jpg";
import Peon from "../music/peon.mp3";
import PeonPic from "../img/peon-vald.jpeg";
import Rencontre from "../music/rencontre.mp3";
import RencontrePic from "../img/disiz-rencontre.png";

import PrevButton from "../components/Player/PrevButton";
import PlayButton from "../components/Player/PlayButton";
import NextButton from "../components/Player/NextButton";
import ProgressBar from "../components/Player/ProgressBar";
import AudioTime from "../components/Player/AudioTime";
import Volume from "../components/Player/Volume";
import LoopButton from "../components/Player/LoopButton";
import AudioImage from "../components/Player/AudioImage";
import Header from "../components/Header/Header";
import PlayList from "../components/Playlist";
import LikeButton from "../components/Player/LikeButton";
const fmtMSS = (s) => new Date(1000 * s).toISOString().substr(15, 4);
let data = [
  {
    id: 1,
    title: "Mauvaix 2X",
    path: MauvaisGazo,
    artist: "Gazo & Ninho",
    picture: MauvaisGazoPic,
  },
  {
    id: 2,
    title: "Peon",
    path: Peon,
    artist: "Vald & Orelsan",
    picture: PeonPic,
  },
  {
    id: 3,
    title: "Allez Pointer",
    path: AllerPointer,
    artist: "Berywam & Féfé",
    picture: AllerPointerPic,
  },
  {
    id: 4,
    title: "Rencontre",
    path: Rencontre,
    artist: "Disiz & Damso",
    picture: RencontrePic,
  },
];
function App() {
  const [audio, setAudio] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);
  const [title, setTitle] = useState("");
  const [artist, setArtist] = useState("");
  const [length, setLength] = useState(0);
  const [time, setTime] = useState(0);
  const [slider, setSlider] = useState(1);
  const [drag, setDrag] = useState(0);
  const [volume, setVolume] = useState(0.8);
  const [shuffled, setShuffled] = useState(false);
  const [looped, setLooped] = useState(false);
  const [muted, setMuted] = useState(false);

  const [tracklist, setTracklist] = useState(data);
  const [currentTrack, setCurrenTrack] = useState(() =>
    "currentTrack" in localStorage
      ? parseInt(localStorage.getItem("currentTrack"))
      : 0
  );
  const [isPlaylistOpen, setIsPlaylistOpen] = useState(true);

  const [likes, setLikes] = useState(() =>
    "likes" in localStorage
      ? JSON.parse(localStorage.getItem("likes"))
      : [false, false, false, false]
  );
  const [theme, setTheme] = useState("");

  useEffect(() => {
    if ("currentTrack" in localStorage) {
      setCurrenTrack(parseInt(localStorage.getItem("currentTrack")));
    }
  }, []);

  const play = () => {
    setIsPlaying(true);
    audio.play();
  };

  const next = () => {
    if (audio != null) {
      if (currentTrack < tracklist.length - 1) {
        setCurrenTrack(tracklist[currentTrack + 1].id - 1);
      }
    }
  };

  const prev = () => {
    if (audio != null) {
      if (currentTrack > 0) {
        setCurrenTrack(tracklist[currentTrack - 1].id - 1);
      } else {
        audio.currentTime = 0;
      }
    }
  };

  const pause = () => {
    setIsPlaying(false);
    audio.pause();
  };

  const mute = () => {
    if (muted) {
      audio.volume = 1;
    } else {
      audio.volume = 0;
    }
    setMuted(!muted);
  };

  const changeTrack = (index) => {
    setCurrenTrack(index - 1);
  };

  const loop = () => {
    setLooped(!looped);
  };

  const like = (id) => {
    likes[id] = !likes[id];
    setLikes([...likes]);
    localStorage.setItem("likes", JSON.stringify(likes));
  };

  useEffect(() => {
    const audio = new Audio(tracklist[currentTrack].path);

    const setAudioData = () => {
      setLength(audio.duration);
      setTime(audio.currentTime);
    };

    const setAudioTime = () => {
      const curTime = audio.currentTime;
      setTime(curTime);
      setSlider(curTime ? ((curTime * 100) / audio.duration).toFixed(1) : 0);
    };

    const setAudioVolume = () => setVolume(audio.volume);

    const setAudioEnd = () => setHasEnded(!hasEnded);

    audio.addEventListener("loadeddata", setAudioData);
    audio.addEventListener("timeupdate", setAudioTime);
    audio.addEventListener("volumechange", setAudioVolume);
    audio.addEventListener("ended", setAudioEnd);

    setAudio(audio);
    setTitle(tracklist[currentTrack].title);
    setArtist(tracklist[currentTrack].artist);

    return () => {
      audio.pause();
    };
  }, []);

  useEffect(() => {
    if (audio != null) {
      pause();
      const val = Math.round((drag * audio.duration) / 100);
      audio.currentTime = val;
    }
  }, [drag]);

  useEffect(() => {
    if (audio != null) {
      audio.volume = volume;
    }
  }, [volume]);

  useEffect(() => {
    if (audio != null) {
      if (looped) {
        play();
      } else {
        next();
      }
    }
  }, [hasEnded]);

  useEffect(() => {
    if (audio != null) {
      audio.src = tracklist[currentTrack].path;
      setTitle(tracklist[currentTrack].title);
      setArtist(tracklist[currentTrack].artist);
      localStorage.setItem("currentTrack", currentTrack);
      play();
    }
  }, [currentTrack]);

  return (
    <>
      <div className="relative z-20 flex flex-col w-full min-h-screen mx-auto bg-slate-500">
        <div className="absolute z-0 w-full h-full bg-center bg-no-repeat bg-cover bg-slate-800 filter blur-lg cover"></div>
        <div className="absolute z-10 w-full h-full bg-center bg-no-repeat bg-cover bg-black/70 "></div>
        <Header />

        <div className="w-full md:flex md:w-[80%] md:space-x-4  mx-auto relative ">
          <div className="relative flex flex-col items-center justify-between w-full md:flex-1 md:py-4 md:rounded-lg md:bg-black/30">
            <Volume
              onClick={mute}
              isMuted={muted}
              value={volume}
              onChange={(e) => {
                setVolume(e.target.value);
              }}
            />

            <AudioImage
              img={tracklist[currentTrack].picture}
              isPlaying={isPlaying}
            />
            <div
              id="player"
              className="z-10 flex flex-col items-center justify-center w-full px-4 py-4 mt-6 space-y-4 text-slate-100"
            >
              <div className="flex items-center justify-between w-full -mb-4">
                <div className="flex flex-col items-start">
                  <span className="text-slate-200">{title}</span>
                  <span className="text-[14px] text-slate-300">{artist}</span>
                </div>
                {likes[currentTrack] === true ? (
                  <LikeButton
                    isLiked={true}
                    onClick={() => like(currentTrack)}
                    fontSize={16}
                  />
                ) : (
                  <LikeButton
                    isLiked={false}
                    onClick={() => like(currentTrack)}
                    fontSize={16}
                  />
                )}
              </div>
              <ProgressBar
                value={slider}
                onChange={(e) => {
                  setSlider(e.target.value);
                  setDrag(e.target.value);
                }}
                onMouseUp={play}
                onTouchEnd={play}
              />
              <AudioTime
                currentTime={`${!time ? "0:00" : fmtMSS(time)}`}
                audioTime={`${!length ? "0:00" : fmtMSS(length)}`}
              />
              <div className="flex items-center justify-between space-x-4">
                <LoopButton onClick={loop} isLooped={looped} />
                <div className="flex items-center justify-between space-x-4">
                  <PrevButton onClick={prev} />
                  {!isPlaying ? (
                    <PlayButton
                      isPlaying={isPlaying}
                      isLoading={isLoading}
                      onClick={play}
                    />
                  ) : (
                    <PlayButton
                      isPlaying={isPlaying}
                      isLoading={isLoading}
                      onClick={pause}
                    />
                  )}
                  <NextButton onClick={next} />
                </div>

                {/* <Volume
                onClick={mute}
                isMuted={muted}
                value={volume}
                onChange={(e) => {
                  setVolume(e.target.value);
                }}
              /> */}
              </div>

              <div
                onClick={() => setIsPlaylistOpen(!isPlaylistOpen)}
                className="w-10 h-1 rounded-full bg-slate-500/50 hover:bg-blue-500 active:bg-blue-500 lg:hover:scale-110 "
              ></div>
            </div>
          </div>

          {isPlaylistOpen && (
            <PlayList
              tracklist={tracklist}
              changeTrack={changeTrack}
              currentTrack={currentTrack}
              likes={likes}
              like={like}
            />
          )}
        </div>
      </div>

      <style jsx="true">
        {`
          .cover {
            background-image: url(${tracklist[currentTrack].picture});
          }
        `}
      </style>
    </>
  );
}

export default App;
